import { createFileRoute } from "@tanstack/react-router"
import { AixContentBody } from "@aix/ui"
import { useAtomValue } from "jotai"
import { BreadcrumbBanner } from "~/components/BreadcrumbBanner"
import POVStoryTemplate from "~/components/Templates/POVStoryTemplate"
import AppLayout from "~/layouts/AppLayout"
import CustomHead from "~/components/SEOHead/CustomHead"
import { navStyleAtom } from "~/context/jotai"
import { getPageSEO } from "~/utils/seo"

const POVVideoPage = () => {
  const breadcrumbItems = [{ label: "Home", href: "/home" }, { label: "POV Story" }]
  const povStorySEO = getPageSEO("templates/pov-story")
  const navStyle = useAtomValue(navStyleAtom)

  return (
    <>
      <CustomHead
        title={povStorySEO.title}
        description={povStorySEO.description}
        keywords={povStorySEO.keywords}
        pageType={povStorySEO.pageType}
        url="https://vidmax.ai/templates/pov-story"
      />

      {navStyle !== "twoTier" && <BreadcrumbBanner items={breadcrumbItems} />}

      <AixContentBody className="sm:[--content-max-width:500px] md:[--content-max-width:700px] xl:[--content-max-width:960px]">
        <POVStoryTemplate />
      </AixContentBody>
    </>
  )
}

function POVVideoPageWrapper() {
  return (
    <AppLayout>
      <POVVideoPage />
    </AppLayout>
  )
}

export const Route = createFileRoute("/templates/pov-story")({
  component: POVVideoPageWrapper,
})
